import axios from "axios";
import {
  // nodeInstanceCS,
  instance,
  instanceStorage,
  instanceUpload,
  imageconvertInstance,
} from "../services/axiosConfig";
import { instanceCS, nodeInstanceCS } from "../services/axiosConfigCS";
import { poolData, indentityPoolId } from "../Uitls/Userpools";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import { awsRegion } from "../Uitls/Util";
import { deriveExportAssetFileName } from "../Uitls/exportAssetFileName";

export const postModuleElements = (payload, cb) => {
  nodeInstanceCS
    .post(`/api/v1/assets/saveUsedContent`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const createUpdateNotification = (payload, cb) => {
  nodeInstanceCS
    .post("/api/v1/notifications", payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getBannerValidationCheckDetail = (damDocNumber, cb) => {
  nodeInstanceCS
    .get(
      `/api/v1/assets/modular-content/validate?damDocNumber=${damDocNumber}`,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const sendBannerValidatonCheckDetails = (options, cb) => {
  nodeInstanceCS
    .post("api/v1/assets/modular-content/validate", options)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const fetchModuleDetails = (moduleId, cb) => {
  instance
    .get(`/api/modulems/integration/v1/modules/${moduleId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getModuleDetailsById = (moduleId, cb) => {
  instance
    .get(`/api/modulems/modules/${moduleId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getBrandsAndCampaigns = (cb) => {
  instance
    .get("/api/modulems/assets/brandcampaigns", {
      headers: { Some: "Something" },
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getRecentlyViewed = (type, cb) => {
  nodeInstanceCS
    .get(`/api/v1/content/recent/getRecentViews?contentType=${type}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getAtomsFromProceed = (assetID, cb) => {
  instance
    .get(`api/modulems/contentstudio/module/atoms?moduleId=${assetID}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

//GET CORE CLAIM CATEGORIES
export const getCoreClaimCategories = (cb, brandId) => {
  instance
    .get(`/api/modulems/brands/${brandId}/categoryclaims`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb("", err, err.response && err.response.status);
    });
};

export const getCoreClaimCategoriesforVeeva = (cb) => {
  instance
    .get("/api/modulems/contentstudio/contentmodules/categories")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb("", err, err.response && err.response.status);
    });
};

//GET Module ID deyails
export const getModuleDetailsByModuleId = (ModuleId, cb, type) => {
  let url =
    type === "veevaModule"
      ? "/api/modulems/contentstudio/contentmodules"
      : "/api/modulems/modules";

  instance
    .get(`${url}/${ModuleId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb("", err, err.response && err.response.status);
    });
};

export const sendSaveModuleIdHistory = (ids, cb, options) => {
  nodeInstanceCS
    .post("/api/v1/content/recent/saveContentHistory", ids, options)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getDeConstStatus = (ids, cb) => {
  instance
    .post("/api/modulems/assets/status", ids)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getAssetsStatus = (cb) => {
  return instance
    .get("api/modulems/assets/status")
    .then((response) => {
      cb(response);
      return response.data;
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const uploadSuppVisual = (formData, options, cb) => {
  instanceStorage
    .post("/api/storagems/assets", formData, options)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
//multipart/form-data

const opt = {
  headers: {
    "Content-Type": "multipart/form-data",
    "Accept-Language": "en-US,en;q=0.9",
    "Access-Control-Allow-Origin": "*",
  },
};

export const browseImages = (formData, cb, requestConfig = {}) => {
  // const mergedOptions = {
  //   ...opt,
  //   ...requestConfig,
  //   headers: {
  //     ...(opt.headers || {}),
  //     ...(requestConfig?.headers || {}),
  //   },
  // };
  nodeInstanceCS
    .post("/api/v1/banner/bannerImage", formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getModulesBusinessRules = (assetId, cb) => {
  return instance
    .get(`/api/modulems/assets/${assetId}/modules`)
    .then((response) => {
      cb(response);
      return response.data;
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

const options = {
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "en-US,en;q=0.9",
    "Access-Control-Allow-Origin": "*",
  },
};
export const cardInfoForcardIds = (formData, cb) => {
  instanceUpload
    .post("api/modulems/contentstudio/modules/claimcategory", formData, options)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const searchModules = (formData, cb, linkedModulesType) => {
  let moduleInUrl =
    linkedModulesType === "nextModule" ? "modules" : "contentmodules";
  instanceUpload
    .post(`api/modulems/contentstudio/${moduleInUrl}/search`, formData, options)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getAssetdetails = (moduleInfo, cb) => {
  const assetType =
    moduleInfo.assetType === "TEMPLATE"
      ? "api/v1/assets/create?assetType=TEMPLATE"
      : "api/v1/assets/create?assetType=BANNER";
  nodeInstanceCS
    .post(`${assetType}`, moduleInfo)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const modifyAsset = (assetId, moduleInfo, cb) => {
  nodeInstanceCS
    .patch(`/api/v1/assets/${assetId}`, moduleInfo)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};


export const saveBackupImageSettings = (payload, cb) => {
  nodeInstanceCS
    .post(`/api/v1/backup-image/saveBackupImage`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getBackupImageSettings = (assetId, cb) => {
  nodeInstanceCS
    .get(`/api/v1/backup-image/getBackupImage/${assetId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const deleteBackupImageSettings = (assetId, cb) => {
  nodeInstanceCS
    .delete(`api/v1/backup-image/deleteBackupImage/${assetId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    })
}

export const searchBanners = (
  type,
  dropdownInfo,
  values,
  bannerNameInput,
  pageNumber,
  madeBy,
  cb,
) => {
  const brandIds = values?.brand?.map((brand) => brand.brandDamId);
  const marketCodes = Array.isArray(values?.market)
    ? values.market.map((market) => market.code || market.countryDamId)
    : [];
  const templateType =
    values?.templateType?.[0]?.displayName === "Animated"
      ? true
      : values?.templateType?.[0]?.displayName === "Static"
        ? false
        : "";
  const contentTypeFlags = Array.isArray(values?.contentType)
    ? values.contentType
        .map((contentType) => {
          if (typeof contentType?.value === "boolean") {
            return contentType.value;
          }
          const normalizedName = `${contentType?.displayName || ""}`
            .trim()
            .toLowerCase();
          if (normalizedName === "one-time content") {
            return true;
          }
          if (normalizedName === "modular content") {
            return false;
          }
          return null;
        })
        .filter((flag) => typeof flag === "boolean")
    : [];
  const hasOneTimeContent = contentTypeFlags.includes(true);
  const hasModularContent = contentTypeFlags.includes(false);
  const isOneTimeBanner =
    hasOneTimeContent && !hasModularContent
      ? true
      : hasModularContent && !hasOneTimeContent
        ? false
        : "";
  const isModularContent =
    hasOneTimeContent && !hasModularContent
      ? false
      : hasModularContent && !hasOneTimeContent
        ? true
        : "";
  // Handle indication names - use comma-separated format
  const indications =
    values?.indication?.map(
      (indication) =>
        indication.label || // Use label first (the display value)
        indication.displayName ||
        indication.indicationLabel ||
        indication.name ||
        indication.id,
    ) || [];

  // Handle MLR status names - use comma-separated format
  const mlrStatuses =
    values?.mlrStatus?.map(
      (status) =>
        status.statusName || status.displayName || status.name || status.id,
    ) || [];
  let url = `api/v1/assets?`;
  let urlParams = [];

  // Always include required parameters
  urlParams.push(`assetType=${type}`);
  urlParams.push(`pageNumber=${pageNumber}`);
  urlParams.push(`pageLimit=20`);
  urlParams.push(`madeBy=${madeBy}`);

  // Add brandIds only if present
  if (brandIds && brandIds.length > 0) {
    brandIds.forEach((brandId) => {
      urlParams.push(`brandId=${brandId}`);
    });
  }

  // Add campaignId only if present
  if (dropdownInfo.campaign && dropdownInfo.campaign.trim() !== "") {
    urlParams.push(`campaignId=${dropdownInfo.campaign}`);
  }

  // Add marketCode only if present (multiple parameters for multiple markets)
  if (marketCodes && marketCodes.length > 0) {
    marketCodes.forEach((marketCode) => {
      urlParams.push(`marketCode=${marketCode}`);
    });
  }

  // Add searchTerm only if present
  if (bannerNameInput && bannerNameInput.trim() !== "") {
    urlParams.push(`searchTerm=${bannerNameInput}`);
  }

  // Add isAnimated only if templateType is explicitly set
  if (templateType !== "") {
    urlParams.push(`isAnimated=${templateType}`);
  }

  // Add isOneTimeBanner only for Banner search and only when content type is explicit
  if (type === "BANNER" && isOneTimeBanner !== "") {
    urlParams.push(`isOneTimeBanner=${isOneTimeBanner}`);
  }

  if (type === "BANNER" && isModularContent) {
    urlParams.push(`isModularContent=${isModularContent}`);
  }

  // Add indications only if present (multiple parameters for multiple indications)
  if (indications.length > 0) {
    indications.forEach((indication) => {
      urlParams.push(`indications=${indication}`);
    });
  }

  // Add MLR statuses only if present (multiple parameters for multiple statuses)
  if (mlrStatuses.length > 0) {
    mlrStatuses.forEach((statusId) => {
      urlParams.push(`mlrStatus=${statusId}`);
    });
  }

  // Join all parameters
  url += urlParams.join("&");

  nodeInstanceCS
    .post(url)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const searchBannersCountBasedOnCreatedBy = (
  type,
  dropdownInfo,
  values,
  bannerNameInput,
  pageNumber,
  madeBy,
  cb,
) => {
  const brandIds = values?.brand?.map((brand) => brand.brandDamId);
  const marketCodes = Array.isArray(values?.market)
    ? values.market.map((market) => market.code || market.countryDamId)
    : [];
  const templateType =
    values?.templateType?.[0]?.displayName === "Animated"
      ? true
      : values?.templateType?.[0]?.displayName === "Static"
        ? false
        : "";

  // Handle indication names - use comma-separated format
  const indications =
    values?.indication?.map(
      (indication) =>
        indication.label || // Use label first (the display value)
        indication.displayName ||
        indication.indicationLabel ||
        indication.name ||
        indication.id,
    ) || [];

  // Handle MLR status names - use comma-separated format
  const mlrStatuses =
    values?.mlrStatus?.map(
      (status) =>
        status.statusName || status.displayName || status.name || status.id,
    ) || [];

  let urlParams = [];

  // Always include required parameters
  urlParams.push(`assetType=${type}`);
  urlParams.push(`pageNumber=${pageNumber}`);
  urlParams.push(`pageLimit=20`);
  urlParams.push(`madeBy=${madeBy}`);

  // Add brandIds only if present
  if (brandIds && brandIds.length > 0) {
    brandIds.forEach((brandId) => {
      urlParams.push(`brandId=${brandId}`);
    });
  }

  // Add campaignId only if present
  if (dropdownInfo.campaign && dropdownInfo.campaign.trim() !== "") {
    urlParams.push(`campaignId=${dropdownInfo.campaign}`);
  }

  // Add marketCode only if present (multiple parameters for multiple markets)
  if (marketCodes && marketCodes.length > 0) {
    marketCodes.forEach((marketCode) => {
      urlParams.push(`marketCode=${marketCode}`);
    });
  }

  // Add searchTerm only if present
  if (bannerNameInput && bannerNameInput.trim() !== "") {
    urlParams.push(`searchTerm=${bannerNameInput}`);
  }

  // Add isAnimated only if templateType is explicitly set
  if (templateType !== "") {
    urlParams.push(`isAnimated=${templateType}`);
  }

  // Add indications only if present (multiple parameters for multiple indications)
  if (indications.length > 0) {
    indications.forEach((indication) => {
      urlParams.push(`indications=${indication}`);
    });
  }

  // Add MLR statuses only if present (multiple parameters for multiple statuses)
  if (mlrStatuses.length > 0) {
    mlrStatuses.forEach((statusId) => {
      urlParams.push(`mlrStatus=${statusId}`);
    });
  }

  let url = `api/v1/assets/fetchCountBasedOnCreatedBy?`;
  // Join all parameters
  url += urlParams.join("&");

  nodeInstanceCS
    .get(url)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getRecentlyViewedBannerCards = (type, cb) => {
  nodeInstanceCS
    .get(`/api/v1/content/recent/getRecentViews?contentType=${type}`, {
      headers: { Some: "Something" },
    })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const sendExport = (exportObj, cb) => {
  nodeInstanceCS
    .post(`/api/v1/filespackage/createBannerZipFile`, exportObj)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getExport = (url, filename, cb) => {
  nodeInstanceCS
    .get(
      `/api/v1/filespackage/getBannerZipFile?fileName=${filename}&fileId=${url}`,
      { responseType: "blob" },
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const putSaveAssets = (assetId, payload, cb) => {
  return nodeInstanceCS
    .put(
      `api/v1/assets/${assetId}/assetpages/assetpagecomponent`,

      payload,
      {},
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getSaveAssets = (assetId, cb) => {
  return nodeInstanceCS
    .get(`api/v1/assets/${assetId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const imagePatch = (assetId, imageurl, cb) => {
  return nodeInstanceCS
    .patch(`/api/v1/assets/${assetId}/patchURL`, imageurl)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// ========================= portion start ==========================

// The API function is included in the EditorHeaderForTemplate.js file, but its main functionality is not being used.
export const cloneBanner = (assetId, formData, cb) => {
  return instanceCS
    .post(`/api/contentms/assets/${assetId}/cloneAsset `, formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// The API function is included in the EditorHeaderForTemplate.js file, but its main functionality is not being used.
export const basedOnBanner = (assetId, formData, cb) => {
  return instanceCS
    .post(
      `/api/contentms/assets/${assetId}/cloneAsset?assetType=BANNER `,
      formData,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// ========================= portion end ==========================

export const deleteBanners = (assetId, cb) => {
  return nodeInstanceCS
    .delete(`api/v1/assets/${assetId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getCognitoSession = (cb) => {
  var userPool = new CognitoUserPool(poolData);
  var cognitoUser = userPool.getCurrentUser();
  if (cognitoUser) {
    cognitoUser.getSession(function (err, session) {
      if (!err) {
        cb(session);
        return;
      }
      cb(undefined);
    });
  } else {
    cb(undefined);
  }
};

export const getCognitoIndentityCredentials = (session, AWS, cb) => {
  AWS.config.region = awsRegion;
  let tokenKey = `cognito-idp.${AWS.config.region}.amazonaws.com/${poolData.UserPoolId}`;
  let logins = {};
  logins[tokenKey] = session.getIdToken().getJwtToken();
  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: indentityPoolId,
    Logins: logins,
  });
  AWS.config.credentials.get((err) => {
    if (!err) {
      cb(AWS.config.credentials);
      return;
    }
    cb(undefined);
  });
};

export const preview = (obj, cb) => {
  nodeInstanceCS
    .post(`api/v1/banner/bannerPage`, obj)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getloggedOut = (cb) => {
  nodeInstanceCS
    .get(`api/v1/validate/token`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const uploadAnImageLink = (formData, cb) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  nodeInstanceCS
    .post(
      `api/v1/banner/${formData.assetId}/images/upload?imageUrl=${formData.imageLink}&imageType=Link`,
      formData.imageLink,
      options  
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const uploadAnImageDragAndDrop = (assetId, formData, cb) => {
  nodeInstanceCS
    .post(
      `api/v1/banner/${assetId}/images/upload?imageType=Upload`,
      formData,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const fileSizeValidation = async (exportObj, cb) => {
  return await nodeInstanceCS
    .post(`/api/v1/filespackage/validate/zip/filesize`, exportObj)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const fileSizeValidationAsync = async (exportObj) => {
  const token = window.localStorage.getItem("userToken");
  let x = await axios({
    method: "POST",
    url: `https://dev-contentapi.indegene.com/api/contentms/filespackage/validate/zip/filesize`,
    headers: { authorization: token },
    data: exportObj,
  });
  return x.json();
};

export const lockUnlockBanner = (bannerid, lockStatus, assetType, cb) => {
  nodeInstanceCS
    .post(
      `/api/v1/banner/${bannerid}?action=${lockStatus}&assetType=${assetType}`,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// ========================= portion start ==========================

// The API function is included in the EditorHeaderForTemplate.js file, but its main functionality is not being used.
export const veevaIntegration = (formData, type, assetId, cb) => {
  instanceCS
    .post(`/api/contentms/assets/${assetId}/veeva/${type}/publish`, formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// The API function is included in the EditorHeaderForTemplate.js file, but its main functionality is not being used.
export const veevaIntegrationHtmlPublish = (formData, assetId, cb) => {
  instanceCS
    .post(`/api/contentms/banner/${assetId}/veeva/html/publish`, formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

// ========================= portion end ==========================

export const LocalizedBusinessrulesModules = (payload, cb) => {
  instance
    .post("api/modulems/contentstudio/modules/businessrules", payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const putGotoEditorModules = (payLoad, cb) => {
  return nodeInstanceCS
    .put(
      `/api/v1/assetModule`,

      payLoad,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getVeevaRuleset = (payload, cb) => {
  instance
    .post("api/modulems/contentstudio/contentmodules/ruleset", payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const putVeevaModuleList = (assetId, payload, cb) => {
  nodeInstanceCS
    .put(`api/v1/assetModule/${assetId}`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getVeevaCardsInleftcont = (payload, cb) => {
  instance
    .post("api/modulems/contentstudio/contentmodules/cardinfo", payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getMlrstatusesInModulecards = (payload, cb) => {
  instance
    .post(
      "/api/modulems/integration/v1/modules/businessRules/statuses",
      payload,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getMLRstatus = (assetId, cb) => {
  nodeInstanceCS
    .patch(`/api/v1/banner/${assetId}/synch/mlrstatus`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getbannerandTemplateDetails = (assetId, cb) => {
  nodeInstanceCS
    .get(`/api/v1/assets/details/${assetId}`)
    .then((response) => {
      cb(response?.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getExpiryNotifications = (cb) => {
  nodeInstanceCS
    .get(`/api/v1/notifications`)
    .then((response) => {
      cb(response?.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getSaveAssetsNodeApi = (assetId, cb) => {
  nodeInstanceCS
    .get(`/api/v1/assets/preview/${assetId}`)
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getNewBrandsAndcampaigns = (cb) => {
  nodeInstanceCS
    .get("/api/v1/brands")
    .then((response) => {
      cb(response?.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getMarketList = (cb) => {
  nodeInstanceCS
    .get("/api/v1/markets")
    .then((response) => {
      cb(response?.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getmmModules = (payload, cb) => {
  instance
    .post(
      `/api/modulems/integration/v1/modules?pageNo=${payload.page}&pageSize=30`,
      {
        productName: payload.productName,
        countryName: payload.countryName,
        searchText: payload.searchText,
        topicName: payload.topicName,
        subtopicName: payload.subtopicName,
        segmentNames: payload.segmentNames,
        indicationIds: payload.indicationIds,
      },
    )
    .then((response) => {
      cb(response);
      // console.log("Response IDs", response.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const expandClaims = (cardId, cb) => {
  instance
    .get(`api/modulems/integration/v1/modules/${cardId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const getChildModules = (moduleId, cb) => {
  instance
    .get(`api/modulems/integration/v1/modules/businessRules/${moduleId}`)
    .then((response) => {
      cb(response);
      // console.log("Response IDs", response.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const imageConversion = (type, body, cb) => {
  nodeInstanceCS
    .post(`api/v1/resources/screenshot?format=${type}`, body)
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const imageConversionBaseURL = (type, body, cb) => {
  nodeInstanceCS
    .post(`${type}`, body, type === "pdf" && { responseType: "blob" })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const generateRsdScreenshot = (payload, cb) => {
  nodeInstanceCS
    .post(`/api/v1/resources/getRSDScreenshots`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const generateRsdPDF = (payload, cb) => {
  nodeInstanceCS
    .post(`/api/v1/resources/rsdPDFGeneration`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getSizesData = (payload, cb) => {
  nodeInstanceCS
    .get(`/api/v1/assets/validation?damdocNumber=${payload}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getAssetsData = async (payload) => {
  try {
    const response = await nodeInstanceCS.get(
      `/api/v1/assets/assetsData/${payload}`,
    );
    return response?.data;
  } catch (err) {
    console.error("Error fetching asset data:", err);
    throw err;
  }
};

export const getAssetsDataTrackChanges = async (payload) => {
  try {
    const response = await nodeInstanceCS.get(
      `/api/v1/assets/rsdTrackChanges/${payload}`,
    );
    return response;
  } catch (err) {
    console.error("Error fetching asset data:", err);
    throw err;
  }
};

export const getRSDAssetStatus = async (id) => {
  try {
    const response = await nodeInstanceCS.get(
      `api/v1/assets/${id}/rsdStatus`,
    );
    return response;
  } catch (err) {
    console.error("Error fetching asset data:", err);
    throw err;
  }
};

export const updateAssetStatus = async (id, payload) => {
  try {
    const response = await nodeInstanceCS.put(
      `api/v1/assets/${id}/rsdStatus`,
      payload,
    );
    return response;
  } catch (err) {
    console.error("Error fetching asset data:", err);
    throw err;
  }
};

export const veevaPublish = (formData, veevaId, cb) => {
  nodeInstanceCS
    .post(`/api/v1/rsd/${veevaId}/publish`, formData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err?.response, errorCode);
    });
};

export const deleteAsset = (assetId, cb) => {
  nodeInstanceCS
    .delete(`api/v1/assets?damDocNumber=${assetId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err.response, errorCode);
    });
};

export const deleteModulesCanvas = (veevaDocId, cb) => {
  const token = window.localStorage.getItem("userToken");
  nodeInstanceCS
    .delete(
      `api/v1/assets/assetpages/modularContent?veevaDocNumber=${veevaDocId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err.response, errorCode);
    });
};

export const getBannerdetailsfromVeeva = (veevaDocNumber, cb) => {
  nodeInstanceCS
    .get(`/api/v1/banner/${veevaDocNumber}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getIndicationsList = (cb) => {
  instance
    .get("/api/modulems/integration/v1/indication")
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const getMlrStatuses = (cb) => {
  nodeInstanceCS
    .get("api/v1/dam/rsd/mlrStatuses")
    .then((response) => {
      cb(response?.data);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};
export const readAndUnreadNotifications = (payload, cb) => {
  nodeInstanceCS
    .post(`/api/v1/notifications`, payload)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const validatePromomats = (promomatsId, cb) => {
  nodeInstanceCS
    .get(`/api/v1/veeva/docIdValidation/${promomatsId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const copyBanner = (modalData, cb) => {
  nodeInstanceCS
    .post(`/api/v1/assets/copyBanner`, modalData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err?.response, errorCode);
    });
};

export const saveEmail = (emailData, cb) => {
  nodeInstanceCS
    .post(`/api/v1/assets/saveUsersGmail`, emailData)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err?.response, errorCode);
    });
};

export const getDocIdfromveeva = (docId, cb) => {
  nodeInstanceCS
    .get(`/api/v1/assets/getVersionIdforRsd/${docId}`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err.response && err.response.status;
      cb("", err, errorCode);
    });
};

export const createOnetimeBanner = (data, cb) => {
  nodeInstanceCS
    .post(`/api/v1/assets/oneTimeBanner`, data)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err?.response, errorCode);
    });
};

export const validateOneTimeBanner = (damDocNumber, cb) => {
  nodeInstanceCS
    .get(
      `/api/v1/assets/validateOneTimeBanner/${encodeURIComponent(damDocNumber)}`,
    )
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err, errorCode);
    });
};

export const getOnetimeAsset = (cb) => {
  nodeInstanceCS
    .get(`/api/v1/assets/getAllOneTimeBannerDetails`)
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      const errorCode = err?.response && err?.response?.status;
      cb("", err, errorCode);
    });
};
